import Stack from '~/client/shared/Stack';
import AlreadyHaveAccountLink from './AlreadyHaveAccountLink';
import LanguageSwitcher from './LanguageSwitcher';
import TermsAndPolicyLinks from './TermsAndPolicyLinks';
import ProtectedByRecaptcha from '../../../ProtectedByRecaptcha';

type Props = {
  isPopover?: boolean;
};

const RegisterBottomLinks: FC<Props> = ({ isPopover }) => (
  <>
    <Stack space="small" alignContent="start">
      <TermsAndPolicyLinks />
      <AlreadyHaveAccountLink isPopover={isPopover} />
      <ProtectedByRecaptcha />
    </Stack>
    {!isPopover && (
      <div className="-mt-9 flex w-1/2 justify-center">
        <LanguageSwitcher optionClassName="block !p-0" />
      </div>
    )}
  </>
);

export default RegisterBottomLinks;
